import { NeuInput } from "./Neu";
import { DateInput } from "./DateInput";
import { useState } from "react";
import { translateText } from "../../api/ai";
import { stripLang } from "../../lib/langInput";

// خريطة صريحة كي يكتشف Tailwind الكلاسات وقت البناء (لا يحلّ التركيبات الديناميكية).
const ACCENT = {
  sky:      { text: "text-sky-500",      border: "border-s-sky-500" },
  violet:   { text: "text-violet-500",   border: "border-s-violet-500" },
  emerald:  { text: "text-emerald-500",  border: "border-s-emerald-500" },
  orange:   { text: "text-orange-500",   border: "border-s-orange-500" },
  fuchsia:  { text: "text-fuchsia-500",  border: "border-s-fuchsia-500" },
  amber:    { text: "text-amber-500",    border: "border-s-amber-500" },
  rose:     { text: "text-rose-500",     border: "border-s-rose-500" },
  cyan:     { text: "text-cyan-500",     border: "border-s-cyan-500" },
};

// حقل إدخال متجانس مع الثيم؛ accent للمسة لون، و raised لإظهار بروز 3D من حاوية خارجية
// (أكثر ثباتاً من ظل داخل الحقل نفسه — خصوصاً حقول الوقت الأصلية على iOS).
export const Field = ({ label, testId, value, onChange, type = "text", accent, icon: Icon, raised, autoLang, onAuto, ...rest }) => {
  const tone = ACCENT[accent] || {};
  const [busy, setBusy] = useState(false);
  if (type === "date") return <DateInput label={label} testId={testId} value={value} onChange={onChange} {...rest} />;
  if (type === "textarea")
    return (
      <div>
        <p className={`label-xs mb-2 flex items-center gap-1.5 ${tone.text || ""}`}>
          {Icon ? <Icon className="h-3.5 w-3.5" /> : null}{label}
        </p>
        <textarea data-testid={testId} value={value || ""} rows={3} {...rest}
          onChange={(e) => onChange(e.target.value)}
          className="w-full rounded-2xl bg-background px-4 py-3 text-sm shadow-neu-in focus:outline-none focus:ring-2 focus:ring-ring" />
      </div>
    );
  const handleBlur = async (e) => {
    rest.onBlur?.(e);
    const text = (value || "").trim();
    if (!autoLang || !onAuto || !text || busy) return;
    setBusy(true);
    try {
      const out = await translateText(text, autoLang === "ar" ? "en" : "ar");
      if (out) onAuto(out);
    } finally {
      setBusy(false);
    }
  };
  const input = (
    <NeuInput
      data-testid={testId}
      type={type}
      value={value}
      onChange={(e) => onChange(autoLang ? stripLang(e.target.value, autoLang) : e.target.value)}
      className={`${tone.border ? `border-s-4 ${tone.border}` : ""} ${raised ? "!shadow-none bg-transparent" : ""}`}
      {...rest}
      onBlur={autoLang ? handleBlur : rest.onBlur}
    />
  );
  return (
    <div>
      <p className={`label-xs mb-2 flex items-center gap-1.5 ${tone.text || ""}`}>
        {Icon ? <Icon className="h-3.5 w-3.5" /> : null}
        {label}
        {busy ? <span className="text-[10px] font-bold text-primary animate-pulse" data-testid={testId ? `${testId}-translating` : undefined}>AI…</span> : null}
      </p>
      {raised ? (
        <div className="rounded-2xl bg-background" style={{ boxShadow: "var(--neu-out)" }} data-testid={testId ? `${testId}-raised` : undefined}>
          {input}
        </div>
      ) : (
        input
      )}
    </div>
  );
};
